import React, { memo } from 'react';

const QuotesIcon = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 32 32">
        <path
            fill={color}
            d="M16 0c-8.832 0-16 7.168-16 16s7.168 16 16 16c8.832 0 16-7.168 16-16s-7.168-16-16-16zM18.256 25.744v3.056h-4.272v-3.088c-2.736-0.576-5.056-2.336-5.232-5.44h3.136c0.16 1.68 1.312 2.992 4.24 2.992 3.136 0 3.84-1.568 3.84-2.544 0-1.328-0.704-2.576-4.272-3.424-3.968-0.96-6.688-2.592-6.688-5.872 0-2.752 2.224-4.544 4.976-5.136v-3.088h4.272v3.12c2.976 0.72 4.464 2.976 4.56 5.424h-3.136c-0.080-1.776-1.024-2.992-3.552-2.992-2.4 0-3.84 1.088-3.84 2.624 0 1.344 1.040 2.224 4.272 3.056s6.688 2.224 6.688 6.256c-0.016 2.928-2.208 4.528-4.992 5.056z"
        />
    </svg>
);

export default memo(QuotesIcon);
